import { confirmDialog, promptDialog } from '@/utils/dialogService';

export default {
  install(app) {
    app.config.globalProperties.$confirm = function confirm(message, options = {}) {
      return confirmDialog(message, options);
    };

    app.config.globalProperties.$prompt = function prompt(options = {}) {
      return promptDialog(options);
    };
  },
};
